// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"Cart_ItemsWrapper__CN4ms"};